export function applyFilters(filterKeys, route, router, loadCallback = null) {
    const query = {...route.query, ...filterKeys, page: 1};

    router.push({query: query}).then(() => {
        if (loadCallback) {
            loadCallback();
        }
    });
}
